import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  people: {
    display: 'flex',
    alignItems: 'center',

    '&, & .scrollArea': {
      gap: '6px',

      '@media screen and (min-width: 1441px)': {
        gap: '8px',
      },
    },

    '& .users-line': {
      position: 'relative',
      overflow: 'hidden',

      '&, & .scrollArea': {
        margin: '-4px -4px -30px 0',
        padding: '4px 14px 30px 0px',
      },

      '&.leftShadow': {
        '&::before': {
          left: 0,
          background: `
        linear-gradient(to right, var(--background-paper) 30%, rgba(255,255,255,0))`,
        },
      },

      '&.rightShadow': {
        '&::after': {
          right: 0,
          background: `
        linear-gradient(to left, var(--background-paper) 30%, rgba(255,255,255,0))`,
        },
      },

      '&::before, &::after': {
        content: "''",
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: 30,
        pointerEvents: 'none',
        zIndex: 10,
      },

      '& .scrollArea': {
        ...mixins.noScroll,
        display: 'flex',
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
      },
    },
  },
}));

export default useStyles;
